import {
  ProgramTemplateDto,
  ProgramTemplateType,
} from "@growth-machine-llc/stridist-api-client";
import React from "react";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { LibraryPrivacyType } from "../../constants";
import {
  GenericTemplateTypeBadge,
  privacyTooltip,
} from "../badge/LibraryPrivacyTypeBadge";

interface ProgramTemplateTypeBadgeProps {
  template: ProgramTemplateDto;
  size?: number;
  showLabel?: boolean;
}

const PROGRAM_TO_LIBRARY_PRIVACY_MAP = {
  [ProgramTemplateType.PUBLIC]: LibraryPrivacyType.PUBLIC,
  [ProgramTemplateType.PRIVATE]: LibraryPrivacyType.PRIVATE,
  [ProgramTemplateType.TEAM]: LibraryPrivacyType.TEAM,
} satisfies Record<ProgramTemplateType, LibraryPrivacyType>;

export function ProgramTemplateTypeBadge({
  template,
  size = 40,
  showLabel = true,
}: ProgramTemplateTypeBadgeProps) {
  const user = useCurrentUser();

  const owner = template.author ?? user;
  const privacyType = PROGRAM_TO_LIBRARY_PRIVACY_MAP[template.type];

  const tooltip = privacyTooltip(
    "program template",
    privacyType,
    privacyType === LibraryPrivacyType.TEAM ? owner?.displayName : undefined,
  );

  return (
    <GenericTemplateTypeBadge
      type={privacyType}
      owner={
        owner
          ? {
              photoUrl: owner.photoUrl,
              displayName: owner.displayName,
            }
          : undefined
      }
      tooltip={tooltip}
      size={size}
      showLabel={showLabel}
    />
  );
}
